import React from "react";
import { connect } from "react-redux";

import {
  getSchoolByID,
  getStudentsHavingBasketItems,
  getSchoolBasketTotalToPay,
  isSchoolBasketExpanded,
  getCreditUsedInBasket,
  getMinimumPaymentAmount,
  basketHasDinnerBookingWithArrear
} from "state/school_money/selectors";
import { setExpandedSchoolBasket, startCheckout } from "state/school_money/actions";

import ExpandingBox from "components/ExpandingBox";
import Button from "components/Button";
import Currency from "components/Currency";
import SchoolLogo from "components/school_money/SchoolLogo";
import StudentBasketItemList from "components/school_money/basket/StudentBasketItemList";
import MinimumPaymentAmountAlert from "components/school_money/basket/MinimumPaymentAmountAlert";
import AlertModal from "components/app/alert/AlertModal";

const DINNER_ALERT_TEXT = "Important: Your student's outstanding dinner arrears will be paid off first. You can still make future bookings, but they may require payment. Please reach out if you have any questions.";

class SchoolBasket extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isTotalPriceValid: true,
      displayDinnerArrearPaymentAlert: false
    }
  }

  onMinimumPaymentAmountAlertClose = () => {
    this.setState({isTotalPriceValid : true});
  }

  expand = () => {
    this.props.setExpandedSchoolBasket(this.props.schoolID);
  }
  collapse = () => {
    this.props.setExpandedSchoolBasket(null);
  }

  startCheckout = () => {
    const { totalPrice, minimumPaymentAmount } = this.props;

    if(totalPrice > 0  && totalPrice < minimumPaymentAmount){
        this.setState({ isTotalPriceValid : false });
        return;
    }
    this.props.startCheckout(this.props.schoolID);
  }

  onPayButtonClick = event => {
    // we've handled this event, so don't allow it to propagate, e.g. to ExpandingBox
    // TODO: find a better way of doing this, as stopPropagation could be problematic
    event.stopPropagation();

    const { basketHasDinnerBookingWithArrear } = this.props;

    if(basketHasDinnerBookingWithArrear) {
      this.setState({ displayDinnerArrearPaymentAlert : true });
      return;
    }

    this.startCheckout();
  }

  onDinnerAlertModalClose = () => {
    this.setState({displayDinnerArrearPaymentAlert : false});
    this.startCheckout();
  }

  render() {

    const { school, studentIDs, totalPrice, isExpanded, creditUsed, minimumPaymentAmount } = this.props;
    const showCreditUsed = Object.values(creditUsed).some(amount => amount > 0);

    return (
        <div>
      <ExpandingBox cssModifier="school_money" expanded={isExpanded} onExpand={this.expand} onCollapse={this.collapse}>
        <ExpandingBox.Header toggleOnClick={true}>
          <div className="school-basket__header">
            <SchoolLogo school={school} cssBlockName="school-basket" />
            <div className="school-basket__school-name">{school.get("name")}</div>
            <div className="school-basket__header-row">
              <div className="school-basket__total-price">
                <div className="school-basket__total-price-label">Total To Pay:</div>
                <Currency className="school-basket__total-price-amount" amount={totalPrice} />
                {
                  minimumPaymentAmount > 0 ?
                  <div className="school-basket__minimum-payment-amount-container">
                    <div className="school-basket__minimum-payment-amount-label">Minimum total amount allowed:</div>
                    <Currency className="school-basket__minimum-payment-amount" amount={minimumPaymentAmount} />
                  </div>
                  :
                  null
                }
              </div>
              <div>
                <Button className="school-basket__pay-button" onClick={this.onPayButtonClick}>Pay</Button>
              </div>
            </div>
            {
              showCreditUsed ?
              <div className="school-basket__header-row school-basket__credit-row">
                <div className="school-basket__dinners-credit">
                  <div className="school-basket__dinners-credit-label">Dinner Credit</div>
                  <Currency className="school-basket__dinners-credit-amount" amount={creditUsed.dinners} />
                </div>
                <div className="school-basket__clubs-credit">
                  <div className="school-basket__clubs-credit-label">Club Credit</div>
                  <Currency className="school-basket__clubs-credit-amount" amount={creditUsed.clubs} />
                </div>
              </div> :
              null
            }
          </div>
        </ExpandingBox.Header>
        <ExpandingBox.Body toggleOnClick={false}>
          <hr className="school-basket__body-hr" />
          <div className="school-basket__body">
            {
              studentIDs.map(studentID => (
                <StudentBasketItemList key={studentID} studentID={studentID} />
              ))
            }
          </div>
        </ExpandingBox.Body>
      </ExpandingBox>
      {!this.state.isTotalPriceValid ? <MinimumPaymentAmountAlert minimumPaymentAmount={ minimumPaymentAmount } onClose={this.onMinimumPaymentAmountAlertClose}/> : null}
      {this.state.displayDinnerArrearPaymentAlert ? <AlertModal alertText={ DINNER_ALERT_TEXT } onClose={this.onDinnerAlertModalClose}/> : null}

      </div>
    );

  }

}

export default connect(
  (state, { schoolID }) => ({
    school: getSchoolByID(state, schoolID),
    studentIDs: getStudentsHavingBasketItems(state, schoolID),
    totalPrice: getSchoolBasketTotalToPay(state, schoolID),
    isExpanded: isSchoolBasketExpanded(state, schoolID),
    creditUsed: getCreditUsedInBasket(state, schoolID),
    minimumPaymentAmount: getMinimumPaymentAmount(state, schoolID),
    basketHasDinnerBookingWithArrear: basketHasDinnerBookingWithArrear(state, schoolID)
  }),
  { setExpandedSchoolBasket, startCheckout }
)(SchoolBasket);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/SchoolBasket.js